/**
 * Utility function to conditionally join CSS class names together
 * @param classes - Array of class names or objects where keys are class names and values are booleans
 * @returns String of joined class names
 */
export function classNames(...classes: (string | boolean | undefined | null | { [key: string]: boolean })[]): string {
  return classes
    .filter(Boolean)
    .map((cls) => {
      if (typeof cls === 'object' && cls !== null) {
        return Object.keys(cls).filter((key) => cls[key]).join(' ');
      }
      return cls;
    })
    .join(' ');
}
